export function Mouse (pEditor)
{
  let moveParagraphCursorBeforeSpaceTM = null;

  let getCurrentRangeStateTM1 = null,
      getCurrentRangeStateTM2 = null,
      getCurrentRangeStateTM3 = null;

  let moveStruct =
      {
        pushMouseLeftButton: false,
        X: 0,
        Y: 0,
        element: null,
        moveTag: 1,
        tmSetXY: false,
        tmMoveOut: false
      };

  let mouseDownLastCoords = {};


  this.mouseClick = (e) =>
  {
    let newBoxElement,
        newSelection,
        newRange,
        isUndoSaved = false;

    if (!e && pEditor.$winContent.event)
    {
      e = pEditor.$winContent.event;
    }

    if (!e)
    {
      return false;
    }

    let element = (BEditor.browser.isIE) ? e.srcElement : e.target;

    if (element && element.getAttribute)
    {
      if (BEditor.browser.isWebKit && element.getAttribute('data-anchorIndex') != null && element.getAttribute('data-anchorIndex') !== '')
      {
        pEditor.anchor.selectAnchorVisualTag(element);
      }

      if (pEditor.isEditorInHeader)
      {
        if (moveStruct.X === e.screenX && moveStruct.Y === e.screenY && element.nodeName === 'BODY')
        {
          pEditor.layer.helpers.removeEmptyAbsElements();
          newBoxElement = pEditor.iFrameDoc.createElement('DIV');
          pEditor.iFrameDoc.body.appendChild(newBoxElement);

          if (BEditor.browser.isIE)
          {
            newBoxElement.style.position = 'absolute';
            newBoxElement.style.left = e.clientX + 'px';
            newBoxElement.style.top = (e.clientY - 5) + 'px';
            newBoxElement.setAttribute('data-autoabs', 'true');
            newBoxElement.style.zIndex = pEditor.layer.coAbsElementZIndex++;
            newRange = pEditor.iFrameDoc.body.createTextRange();
            newRange.moveToElementText(newBoxElement);
            newRange.select();
          }
          else if (BEditor.browser.isWebKit)
          {
            newBoxElement.style.position = 'absolute';
            newBoxElement.style.left = e.clientX + 'px';
            newBoxElement.style.top = (e.clientY - 5) + 'px';
            newBoxElement.setAttribute('data-autoabs', 'true');
            newBoxElement.style.zIndex = pEditor.layer.coAbsElementZIndex++;
            newBoxElement.innerHTML = '&nbsp;';

            newSelection = iFrame.getSelection();

            if (newSelection)
            {
              newSelection.removeAllRanges();
              newRange = pEditor.iFrameDoc.createRange();
              newRange.selectNodeContents(newBoxElement);
              newRange.collapse(true);
              newSelection.addRange(newRange);

              pEditor.layer.objectFactory.selectNewElement(newBoxElement);
              pEditor.layer.objectFactory.fixAllAbsElements();
            }
          }
          else
          {
            newBoxElement.innerHTML = '<br>';
            newSelection = iFrame.getSelection();

            if (newSelection.rangeCount > 0)
            {
              newSelection.removeAllRanges();
            }

            newRange = pEditor.iFrameDoc.createRange();
            newRange.selectNodeContents(newBoxElement);
            newSelection.addRange(newRange);
            newBoxElement.style.position = 'absolute';
            newBoxElement.style.left = e.clientX + 'px';
            newBoxElement.style.top = e.clientY + 'px';
            newBoxElement.setAttribute('data-autoabs', 'true');
            newBoxElement.style.zIndex = pEditor.layer.coAbsElementZIndex++;
            newRange.collapse(true);

            pEditor.layer.objectFactory.fixAllAbsElements();
          }

          pEditor.undoRedo.saveUndoDo(true);
          isUndoSaved = true;
        }
      }
    }

    pEditor.helpers.dom.setUniqElement(e);

    if (!isUndoSaved)
    {
      pEditor.undoRedo.saveUndo();
    }

    pEditor.pToolbar.refreshState();
    pEditor.pThis.EditorClicked.fireHandlers();
  };


  this.mouseDown = (e) =>
  {
    let element;

    if (!e && pEditor.$winContent.event)
    {
      e = pEditor.$winContent.event;
    }

    if (!e)
    {
      return false;
    }

    BEditor.dropdowns.closeAllDropdowns();
    pEditor.copyPaste.hideAutoCleaningMessage();
    pEditor.isDropdownOpen = false;

    if (BEditor.browser.isIE)
    {
      if (moveParagraphCursorBeforeSpaceTM) clearTimeout(moveParagraphCursorBeforeSpaceTM);
      moveParagraphCursorBeforeSpaceTM = setTimeout(pEditor.moveParagraphCursorBeforeSpace, 1);
    }

    mouseDownLastCoords.X = e.clientX;
    mouseDownLastCoords.Y = e.clientY;
    moveStruct.X = e.screenX;
    moveStruct.Y = e.screenY;

    element = (BEditor.browser.isIE) ? e.srcElement : e.target;

    if ((BEditor.browser.isIE || BEditor.browser.isGecko) && element && element.nodeName === 'IMG' && pEditor.$Style(element, 'position').toLowerCase() === 'absolute')
    {
      pEditor.image.controls.hideControlsTemp();
    }
  };


  this.mouseUp = (e) =>
  {
    let i,
        element,
        elements,
        currentRange = pEditor.range.getCurrent(true);

    if (!e && pEditor.$winContent.event)
    {
      e = pEditor.$winContent.event;
    }

    if (!e)
    {
      return false;
    }

    if (pEditor.isMultiEditorMode)
    {
      setTimeout(pEditor.range.save, 1);
      setTimeout(pEditor.range.checkSelection, 1);
    }
    else
    {
      pEditor.range.save();
      pEditor.range.checkSelection();
    }

    if (pEditor.style.formatPainter.copyTextStyle.currentStyle != null)
    {
      pEditor.style.formatPainter.pasteStyle();
    }

    element = (BEditor.browser.isIE) ? e.srcElement : e.target;

    if (BEditor.browser.isIE)
    {
      if (moveParagraphCursorBeforeSpaceTM) clearTimeout(moveParagraphCursorBeforeSpaceTM);
      if (getCurrentRangeStateTM1) clearTimeout(getCurrentRangeStateTM1);
      if (getCurrentRangeStateTM2) clearTimeout(getCurrentRangeStateTM2);
      if (getCurrentRangeStateTM3) clearTimeout(getCurrentRangeStateTM3);

      pEditor.moveParagraphCursorBeforeSpace();
      pEditor.range.getCurrentState();

      if (element && element.nodeName && pEditor.$Style(element, 'position').toLowerCase() === 'absolute')
      {
        getCurrentRangeStateTM1 = setTimeout(pEditor.range.getCurrentState, 500);
        getCurrentRangeStateTM2 = setTimeout(pEditor.range.getCurrentState, 1000);
        getCurrentRangeStateTM3 = setTimeout(pEditor.range.getCurrentState, 1500);
      }
    }

    if ((BEditor.browser.isIE || BEditor.browser.isGecko) && element && element.nodeName && element.nodeName === 'IMG' && pEditor.$Style(element, 'position').toLowerCase() === 'absolute')
    {
      pEditor.image.controls.showControlsTemp();
    }

    if (!(currentRange && currentRange.startContainer.nodeName === 'DIV' && currentRange.startContainer.hasAttribute('data-waelementhidecursor')))
    {
      elements = pEditor.iFrameDoc.body.querySelectorAll('div[data-waelementhidecursor]');

      for (i = elements.length; i--;)
      {
        if (elements[i] && elements[i].parentNode)
        {
          elements[i].parentNode.removeChild(elements[i]);
        }
      }
    }
  };


  this.globalMouseMove = () =>
  {
    if (pEditor.key.isRangeKeyUp)
    {
      pEditor.key.isRangeKeyUp = false;
      pEditor.range.save();

      if (BEditor.browser.isIE)
      {
        pEditor.font.color.getCurrentForeColor();
        pEditor.font.background.getCurrentBackColor();
        pEditor.link.remover.queryRemoveLinkEnabled();
      }
    }
  };


  this.mouseDragDrop = (e) => //TODO:Dime ???
  {
    if (isWebKit && pEditor.isMultiEditorMode)
    {
      pEditor.pParent.mouseMultiDragDrop();
    }
    else
    {
      this.mouseDragDropDo();
    }
  };


  this.mouseDragDropDo = () =>
  {
    if (!BEditor.browser.isIE)
    {
      for (let i = 1; i <= 3; i++)
      {
        setTimeout(pEditor.contentChecker.checkContentChanged, (37 * i * i * i));
        setTimeout(pEditor.frameSize.setSize, (37 * i * i * i + 100));
      }
    }
  };


  Object.defineProperty(this, 'mouseDownLastCoords', { get: () => mouseDownLastCoords});
}